import { useCallback, useState } from "react";

export function useFormWithErrors<F, E extends object>(initialForm: F | (() => F)) {
  const [form, setForm] = useState<F>(initialForm);
  const [fieldErrors, setFieldErrors] = useState<E>({} as E);

  const updateForm = useCallback((f: F) => {
    setForm(f);
    setFieldErrors({} as E);
  }, []);

  return { form, fieldErrors, setFieldErrors, updateForm };
}
